<script>
    export let tab = 'info';

    function showInfoTab() {
        tab = 'info';
    }

    function showScoreTab() {
        tab = 'scores';
    }

    function showKisa1Tab() {
        tab = 'kisa1';
    }

    function showKisa2Tab() {
        tab = 'kisa2';
    }

    function showKisa3Tab() {
        tab = 'kisa3';
    }

    function showKisa4Tab() {
        tab = 'kisa4';
    }

</script>
<div class="page">
    <div class="container">
        <div class="row">
            <div class="col-xs-12 col-md-8">
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link {tab === 'info' ? 'active' : ''}" href="/perjantailiiga"
                           on:click|preventDefault={showInfoTab}>Info</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link {tab === 'scores' ? 'active' : ''}" href="/perjantailiiga"
                           on:click|preventDefault={showScoreTab}>Tulokset</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link {tab === 'kisa1' ? 'active' : ''}" href="/perjantailiiga"
                           on:click|preventDefault={showKisa1Tab}>Kisa 1 (11.3.)</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link {tab === 'kisa2' ? 'active' : ''}" href="/perjantailiiga"
                           on:click|preventDefault={showKisa2Tab}>Kisa 2 (25.3.)</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link {tab === 'kisa3' ? 'active' : ''}" href="/perjantailiiga"
                           on:click|preventDefault={showKisa3Tab}>Kisa 3 (8.4.)</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link {tab === 'kisa4' ? 'active' : ''}" href="/perjantailiiga"
                           on:click|preventDefault={showKisa4Tab}>Kisa 4 (22.4.)</a>
                    </li>
                </ul>
                <h1>Perjantailiiga</h1>
                {#if tab === 'info'}
                    <div>
                        <p><i>Oletko kiinnostunut leppoisasta kisailusta?</i></p>
                        <p><strong>Mikä se on ja kuka siihen voi osallistua?</strong></p>
                        <p><i>4 kisaa, neljänä perjantaina. Kolme parasta tulosta lasketaan mukaan. Sarjojen voittajille
                            pieni palkinto. Kisat alkaa klo 18.00 lämmittelyllä, jonka jälkeen tehdään
                            oma suoritus. Kisoihin osallistuminen ei vaadi salin täysjäsenyyttä. Myös 10x- ja
                            omatoimikortilla
                            voi käydä kisailemassa.</i></p>
                        <!--p><a href="https://forms.gle/k8PLwaaTrfkhc9kG8">Ilmoittaudu mukaan</a></p -->

                        <p>Kisat järjestetään joka toinen perjantai klo 18.00 (11.3, 25.3, 8.4. 22.4.)</p>
                        <img style="width: 60%" src="/svelte-site/img/ajankohtaista/20211106_kari.jpg" alt="Kari">
                        <p>Perjantailiiga on matalan kynnyksen leppoisaa ja hyväntuulista kisailua. Se on tarkoitettu
                            pienestä
                            kisailusta kiinnostuneille harrastajille, jotka haluavat haastaa itseään.
                        </p>
                        <p>Kaikki perjantailiigassa käytössä olevat lajit ovat yksinkertaisia - eivät kuitenkaan
                            välttämättä
                            kevyitä.
                            Lajeissa ei ole korkeaa taitotasoa vaativia liikkeitä. Lajeina on mieluummin soutua ja
                            käsipainotempausta
                            kuin muscle uppeja ja käsilläkävelyä.
                        </p>
                        <p>Liigassa jaetaan pisteitä siten, että ensimmäiseksi tullut saa 100 pistettä, toinen 95, jne.
                            Kolmen
                            parhaan kisan tulokset lasketaan yhteen. Osallistumalla vähintään kolmeen kisaan on mukana
                            kokonaiskisassa. Kaikkiin kisoihin osallistumalla heikoin tulos tiputetaan lopputuloksista
                            pois.
                        </p>
                        <img style="width: 60%" src="/svelte-site/img/ajankohtaista/20211106_thrusterin-jalkeen.jpg"
                             alt="Thruster">

                        <!--p>Sarjoja muodostetaan toiveiden ja palautteiden mukaan. Avoin sarja on varmasti tulossa, mutta
                            esim. Masters-sarjat (40v+?, 50v+?) otetaan mieluusti mukaan, jos osallistujia on niihin
                            tarpeeksi.
                        </p-->
                        <!--p>Aloitetaan perjantailiigan ensimmäinen kisakierros maaliskuun alussa. Ilmoitamme tarkemman
                            päivämäärän myöhemmin. Voitte alkaa pikkuhiljaa jo hieromaan mankkua käsiin ja varpaitten
                            väliin, sillä kohta päästään ottamaan mittaa muista treenaajista. Leikkimielisesti
                            tietenkin.</p-->
                        <p>
                            Konsepti on vasta aluillaan, eli otamme mieluusti vastaan kehitysideoita ja toiveita
                            Perjantailiigan
                            järjestämisestä. Jokainen neljän perjantain ralli on oma kisarupeamansa, joten sääntöjä,
                            liikkeitä
                            ja lajirepertuaaria ehditään hienosäätää aina seuraavaan kisasettiin oikein hyvin.
                        </p>
                        <div class="col-xs-12 col-md-8"><img style="width: 100%"
                                                             src="/svelte-site/img/blog/kahvakuulat-4-1500x630.jpg"
                                                             alt="Ole yhteydessä"></div>
                        <p>Tsemppiä!</p>
                    </div>
                {/if}
                {#if tab === 'scores'}
                    <div>
                        <h3>Tulokset</h3>
                        <strong>Avoin Miehet</strong>
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>Sija</th>
                                <th>Nimi</th>
                                <th>Kokonaispisteet</th>
                                <th>Kisa 1 / pisteet</th>
                                <th>Kisa 2 / pisteet</th>
                                <th>Kisa 3 / pisteet</th>
                                <th>Kisa 4 / pisteet</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>1</td>
                                <td>Jaakko</td>
                                <td>195</td>
                                <td>30 kcal / 100</td>
                                <td>54 / 95</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Jussi</td>
                                <td>190</td>
                                <td>28 kcal / 90</td>
                                <td>57 / 100</td>
                                <td></td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>3</td>
                                <td>Miska</td>
                                <td>175</td>
                                <td>29 kcal / 95</td>
                                <td>47 / 80</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Markus</td>
                                <td>170</td>
                                <td>29 kcal / 95</td>
                                <td>46 / 75</td>
                                <td></td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>4</td>
                                <td>Mikko</td>
                                <td>170</td>
                                <td>20 kcal / 85</td>
                                <td>51 / 85</td>
                                <td></td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>5</td>
                                <td>Teemu</td>
                                <td>90</td>
                                <td>0 / 0</td>
                                <td>52 / 90</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Pekka</td>
                                <td>80</td>
                                <td>5 kcal / 80</td>
                                <td>0 / 0</td>
                                <td></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        <strong>Avoin Naiset</strong>
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>Sija</th>
                                <th>Nimi</th>
                                <th>Pisteet</th>
                                <th>Kisa 1 / pisteet</th>
                                <th>Kisa 2 / pisteet</th>
                                <th>Kisa 3 / pisteet</th>
                                <th>Kisa 4 / pisteet</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>1</td>
                                <td>Iida</td>
                                <td>200</td>
                                <td>21 kcal / 100</td>
                                <td>74 / 100</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Jenny</td>
                                <td>190</td>
                                <td>9 kcal / 95</td>
                                <td>65 / 95</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Jaana</td>
                                <td>180</td>
                                <td>8 kcal / 90</td>
                                <td>36 / 90</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Heidi</td>
                                <td>85</td>
                                <td>4 kcal / 85</td>
                                <td>0 / 0</td>
                                <td></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                {/if}
                {#if tab === 'kisa1'}
                    <strong>Kisa 1.</strong><br/>
                    <p>Tee kolme (3) kierrosta seuraavia liikkeitä kahden minuutin ajan. Pidä kierrosten välissä
                        minuutin tauko.</p>
                    <ul>
                        <li>Käsipainotempaus vuorokäsin x 16 (M22.5kg/N15kg)</li>
                        <li>Burpeeleuka x 8</li>
                        <li>Souda loppuaika kahdesta minuutista.</li>
                    </ul>
                    <p>Soutukalorit lasketaan yhteen lopulliseksi tulokseksi.</p>
                {/if}
                {#if tab === 'kisa2'}
                    <strong>Kisa 2.</strong><br/>
                    <p>Tee kaksi (2) EMOM3:sta, jossa välissä minuutin "tauko", jonka aikana ladataan samaan tankoon
                        Mave painot</p>
                    <p>1. EMOM3</p>
                    <ul>
                        <li>20 sek - rengaspito</li>
                        <li>Loppuminuutti: Thruster (M40kg/N30kg)</li>
                    </ul>
                    <p>Minuutin "tauko", jonka aikana lastaat itse oman maastavetotankosi valmiiksi.</p>
                    <p>2. EMOM3</p>
                    <ul>
                        <li>10 x Etuheilautus kahdella kahvakuulalla (M 2 x 16kg / N 2 x 12kg)</li>
                        <li>Loppuminuutti: Mave (M 100kg/N 70kg)</li>
                    </ul>
                    <p>Tulos: Maastavedot ja Thrusterit lasketaan yhteen.</p>

                {/if}
                {#if tab === 'kisa3'}
                    <strong>Kisa 3.</strong><br/>
                    <p><strong>Toistot:</strong> 20 - 14 - 8 - 2</p>
                    <p><strong>Liikkeet: </strong></p>
                    <ul>
                        <li>Askellus boxille levypainolla</li>
                        <li>Linkkuveitsi levypainolla</li>
                    </ul>
                    <p>Lopuksi: Raaka rinnalleveto x 8 (M 45kg / N 30kg)</p>
                    <br>
                    <p>Mittaa kellolla kokonaisaika. Tee ensin neljä kierrosta askellusta boxin päälle. Jokaisella
                        kierroksella toistojen määrä vähenee. Näiden neljän kierroksen jälkeen tehdään raaka
                        rinnalleveto x 8. Ota ylös kokonaisaika.</p>
                    <p>Painot: <br>
                        Miehille 20kg ja naisille 15kg levypaino käytettäväksi sekä boxille nousussa, että
                        linkkuveitsessä.</p>
                    <p>Boxille nousussa on huomioitava, että lantio ojentuu suoraksi jokaisella nousulla, kuten
                        boxihypyssä. Boxia ei siis vain ylitetä, vaan lantio ojennetaan suoraksi.</p>
                    <p>Linkkuveitsessä hartioiden on noustava reilusti maasta ja levypainolla tähdätään nilkkoihin.
                        Levypaino koskettaa takana maata samaan aikaan kuin jalat edessä.</p>

                {/if}
                {#if tab === 'kisa4'}
                    <strong>Kisa 4.</strong><br/>
                    <p>Tee kolme kolmen minuutin AMRAP treeniä. Treenien välissä on minuutin "lepo" jonka aikana joko
                    hyppäät 30 naruhyppyä tai lastaat tangon kyykkyä varten. </p>
                    <p>Anna tuomarillesi tarkat ohjeet kierrosten laskuista, koska tämä on hieman haastavampi tuomaroida.</p>
                    <ul>
                        <li><strong>1. AMRAP3:</strong></li>
                        <li>BOS (ball over shoulder) x 9 (M10kg/7kg)</li>
                        <li>Punnerrus tankoa vasten x 9</li>
                        <li>Kulmasoutu lattiakosketuksella x 9</li>
                    </ul>
                    <ul>
                        <li><strong>Minuutin siirtyminen seuraavaan treeniin</strong></li>
                        <li>Hyppynaru x 30</li>
                    </ul>
                    <ul>
                        <li><strong>2. AMRAP3:</strong></li>
                        <li>BOS (ball over shoulder) x 6 (M10kg/7kg)</li>
                        <li>Goblet -kyykky x 6 (M24kg/N16kg)</li>
                        <li>Pistoolikyykky x 3/jalka</li>
                    </ul>
                    <ul>
                        <li><strong>Minuutin siirtyminen seuraavaan treeniin</strong></li>
                        <li>Hyppynaru x 30</li>
                    </ul>
                    <ul>
                        <li><strong>3. AMRAP3:</strong></li>
                        <li>BOS (ball over shoulder) x 3 (M10kg/7kg)</li>
                        <li>Varpaat tankoon x 3</li>
                        <li>Wall walk x 3 (Teipit olkapään alle ja 25cm seinästä. Käsien on osuttava teippeihin)</li>
                    </ul>
                    <ul>
                        <li><strong>Minuutin siirtyminen seuraavaan treeniin</strong></li>
                        <li>Nosta tanko kyykkytelineeseen ja lataa sopivat painot</li>
                   </ul>
                   <ul>
                       <li><strong>3. AMRAP3:</strong></li>
                       <li>Takakyykky - laske toistot ja ilmoita paino mitä käytit.</li>
                       <li>M 85 - 105kg tangolla / N 65 - 85 kg tangolla.</li>
                   </ul>

                {/if}
            </div>
        </div>
    </div>
</div>
